import api from '.';

export interface BusinessUnitGroup {
  id: number;
  name: string;
  createdAt?: string;
  updatedAt?: string;
  deletedAt?: string | null;
}

interface GetBusinessUnitGroupsResponse {
  data: BusinessUnitGroup[];
}

export async function getBusinessUnitGroups(): Promise<GetBusinessUnitGroupsResponse> {
  const { data } = await api.get('/business-unit-groups');
  return data;
}

export async function getBusinessUnitGroup(id: number): Promise<BusinessUnitGroup> {
  const { data } = await api.get(`/business-unit-groups/${id}`);
  return data;
}